import { render, staticRenderFns } from "./MeanOfCommunicationSelect.vue?vue&type=template&id=bb13f74c&"
import script from "./MeanOfCommunicationSelect.vue?vue&type=script&lang=js&"
export * from "./MeanOfCommunicationSelect.vue?vue&type=script&lang=js&"
import style0 from "./MeanOfCommunicationSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports